<template>
    <c-contract-editor
        :title     = "$t('contract.esc.fulltitle')"
        :unit-data = "unitData"
        @store     = "onStore"
        @edit      = "onEdit"
        @start     = "onStart"
        @end       = "onEnde"
    >
        <template v-slot:additional>
            <v-row class="no-frame">
                <v-col class="no-frame pr-1  col-4">
                    <f-currency-field-rw
                        class="mt-1"
                        :label        = "$t('contract.esc.costs')"
                        :readonly     = "readonly"
                        v-model       = "unitData.costs"
                        :hide-details = "true"
                    />
                </v-col>
                <v-col class="no-frame col-4">
                    <f-enum-select-rw
                        v-model       = "unitData.gadget"
                        :label        = "$t('contract.esc.gadgetRent')"
                        :readonly     = "readonly"
                        module        = "msd"
                        type          = "escGadgetRentType"
                        :hide-details = "true"
                    />
                </v-col>
                <v-col class="no-frame pl-1 col-4">
                    <f-currency-field-rw
                        class="mt-1"
                        :label        = "$t('contract.esc.rentPerYear')"
                        :readonly     = "readonly"
                        v-model       = "unitData.rent"
                        :hide-details = "true"
                    />
                </v-col>

            </v-row>

            <v-row class="no-frame mt-1">
                <v-col class="no-frame pr-1 col-4">
                    <f-currency-field-rw
                        :label        = "$t('contract.esc.standByPerYear')"
                        :readonly     = "readonly"
                        v-model       = "unitData.standBy"
                        :hide-details = "true"
                    />
                </v-col>

                <v-col class="no-frame col-4">
                    <f-currency-field-rw
                        :label        = "$t('contract.esc.phoneCosts')"
                        :readonly     = "readonly"
                        v-model       = "unitData.phoneCosts"
                        :hide-details = "true"
                    />
                </v-col>
                <v-col class="no-frame pl-1 col-4">
                    <f-currency-field-rw
                        :label        = "$t('contract.esc.guardCosts')"
                        :readonly     = "readonly"
                        v-model       = "unitData.guardCosts"
                        :hide-details = "true"
                    />
                </v-col>
            </v-row>
        </template>
     </c-contract-editor>
</template>

<script>

import Core             from "@/modules/core/service/Core";
import Contract         from "@/modules/msd/company/contract/service/Contract";
import CContractEditor  from "@/modules/msd/company/contract/components/controls/CContractEditor.vue";
import FCurrencyFieldRw from "@/modules/core/components/utils/FCurrencyFieldRw.vue";
import FEnumSelectRw    from "@/modules/core/components/utils/FEnumSelectRw.vue";

export default {
    name: "CContractEscEditor",

    components: {
        FEnumSelectRw,
        FCurrencyFieldRw,
        CContractEditor,
    },

    props: {
        unit: {
            default: function () {
                return {
                    contractEscId   : null,
                    contractEscStart: null,
                    escGadget       : null,
                    escRent         : null,
                    escStandby      : null,
                    escPhoneCosts   : null,
                    escGuardCosts   : null,
                    escCosts        : null,
                }
            }
        }
    },

    data: () => ({
        readonly: true,
        unitData: {
            start         : null,
            gadget        : null,
            costs         : null,
            guardCosts    : null,
            phoneCosts    : null,
            standByPerYear: null,
            rentPerYear   : null,
            gadgetRent    : null
        }
    }),

    mounted() {
        this.setData();
    },

    watch: {
        unit () {
            this.setData();
        }
    },

    methods: {
        onStore () {
            Contract.unit.saveEsc(this.unit.id, this.unit.contractEscId, this.unitData).then(() => {
                this.unit.contractEscStart = this.unitData.start;
                this.unit.contractEscExpiration = this.unitData.end;
                this.unit.escCosts         = this.unitData.costs;
                this.unit.escGuardCosts    = this.unitData.guardCosts;
                this.unit.escPhoneCosts    = this.unitData.phoneCosts;
                this.unit.escStandby       = this.unitData.standBy;
                this.unit.escRent          = this.unitData.rent;
                this.unit.escGadget        = this.unitData.gadget ? this.unitData.gadget.id : null;
                Core.message.hint(this, this.$t('contract.edit.stored'));
            });
        },

        onEdit (readonly) {
            this.readonly = readonly;
        },

        onStart (value) {
            this.unitData.start = value;
        },

        onEnde (value) {
            this.unitData.end = value;
        },

        setData () {
            this.unitData.start      = this.unit.contractEscStart;
            this.unitData.end        = this.unit.contractEscExpiration;
            this.unitData.costs      = this.unit.escCosts;
            this.unitData.guardCosts = this.unit.escGuardCosts;
            this.unitData.phoneCosts = this.unit.escPhoneCosts;
            this.unitData.standBy    = this.unit.escStandby;
            this.unitData.rent       = this.unit.escRent;
            this.unitData.gadget     = { id: this.unit.escGadget };
        },
    }
}
</script>

<!--suppress CssUnusedSymbol -->
<style scoped>

::v-deep .v-list-item__title {
    font-size: 13px;
}
</style>